import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const items = ['menos saturado', 'con la cabeza más clara', 'sabiendo qué decir cuando algo te molesta', 'con más seguridad para poner límites', 'reaccionando menos en caliente', 'llevándote menos trabajo mental a casa', 'con mejores herramientas para afrontar días difíciles'];
export function TransformationSection() {
  return <section className="w-full bg-bg-warm py-20 md:py-28 px-4" data-id="element-262" data-mp="2nxqxunfz7y24">
      <div className="max-w-4xl mx-auto" data-id="element-263" data-mp="2j5peyioaz934">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-264" data-mp="2j4o1k7jteai8">
          <div className="inline-flex items-center gap-2 bg-rose-bg text-rose px-4 py-1.5 rounded-full mb-5" data-id="element-265" data-mp="206v0zbwnyco0">
            <span className="text-xs font-bold tracking-widest" data-id="element-266" data-mp="fasrdd41jc5b">
              ✨ LA TRANSFORMACIÓN
            </span>
          </div>
          <h2 className="font-serif font-bold text-3xl sm:text-4xl md:text-5xl text-ink leading-[1.1] uppercase tracking-tight" data-id="element-267" data-mp="k3dig6vkbb55">
            Imaginá terminar{' '}
            <span className="font-serif-italic text-rose font-normal normal-case" data-id="element-268" data-mp="ab7t74wp37tn">
              tu jornada…
            </span>
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 gap-3" data-id="element-269" data-mp="xzr29mnkjoms">
          {items.map((it, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.05
        }} className="flex items-start gap-3 bg-white border border-line rounded-2xl p-4 shadow-sm" data-id="element-270" data-mp="12yke7an7j7ku" data-mpi={i}>
              <span className="flex-shrink-0 w-7 h-7 rounded-full bg-rose/15 flex items-center justify-center mt-0.5" data-id="element-271" data-mp="1fb5xs8znbaj4">
                <CheckIcon className="w-4 h-4 text-rose" strokeWidth={3} data-id="element-272" data-mp="1aj4gu9rj8vmr" />
              </span>
              <span className="text-ink text-sm md:text-base" data-id="element-273" data-mp="15luuj2zfx035">{it}</span>
            </motion.div>)}
        </div>

        <motion.blockquote initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="bg-white border border-line rounded-3xl p-8 md:p-12 mt-10 text-center shadow-sm" data-id="element-274" data-mp="11l2la9qkiv6v">
          <p className="text-ink text-lg md:text-xl leading-relaxed" data-id="element-275" data-mp="mobj5spif5dk">
            No se trata de eliminar todos los problemas del trabajo.
          </p>
          <p className="font-serif-italic text-rose text-xl md:text-2xl mt-3" data-id="element-276" data-mp="2h00369ally4t">
            Se trata de que no todos los problemas se queden viviendo en tu
            cabeza.
          </p>
        </motion.blockquote>
      </div>
    </section>;
}